import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Distribuicao {
  label: string;
  quantidade: number;
}

export interface SerieMensal {
  mes: string;
  aReceber: number;
  aPagar: number;
}

export interface ClientesResumo {
  total: number;
  ativos: number;
  inativos: number;
  novosNoPeriodo: number;
}

export interface FinanceiroResumo {
  totalEmAberto: number;
  qtdEmAberto: number;
  totalVencido: number;
  qtdVencido: number;
  totalLiquidadoNoPeriodo: number;
  qtdLiquidadoNoPeriodo: number;
}

export interface TicketsResumo {
  total: number;
  abertos: number;
  finalizados: number;
  novosNoPeriodo: number;
  porStatus: Distribuicao[];
  porPrioridade: Distribuicao[];
  porTipo: Distribuicao[];
  porSegmento: Distribuicao[];
  porResponsavel: Distribuicao[];
  porCliente: Distribuicao[];
}

export interface DashboardResumo {
  dataInicio: string;
  dataFim: string;
  segmento: string | null;
  clientes: ClientesResumo;
  contaPagar: FinanceiroResumo;
  contaReceber: FinanceiroResumo;
  tickets: TicketsResumo;
  fluxoMensal: SerieMensal[];
}

@Injectable({ providedIn: 'root' })
export class DashboardService {

  private apiURL = environment.apiBaseUrl + 'dashboard';

  constructor(private http: HttpClient) { }

  resumo(dataInicio?: string | null, dataFim?: string | null, segmento?: string | null): Observable<DashboardResumo> {
    let params = new HttpParams();
    if (dataInicio) {
      params = params.set('dataInicio', dataInicio);
    }
    if (dataFim) {
      params = params.set('dataFim', dataFim);
    }
    if (segmento) {
      params = params.set('segmento', segmento);
    }
    return this.http.get<DashboardResumo>(`${this.apiURL}/resumo`, { params });
  }
}
